export const MemberType = {
  MEETINGS_AND_EVENTS: 'meetings and events',
  TRAVEL_AGENT: 'travel agent',
  TRAVEL_AGENT_ME: 'travel agent|meetings and events',
  TRAVEL_ARRANGER: 'travel arranger',
  TRAVEL_ARRANGER_ME: 'travel arranger|meetings and events'
}

export const MemberTypes = [
  {
    code: 'meetings_and_events',
    label: 'ppMeetingsAndPlannerRole',
    value: MemberType.MEETINGS_AND_EVENTS
  },
  {
    code: 'travel_agent',
    label: 'ppTravelAgentRole',
    value: MemberType.TRAVEL_AGENT
  },
  {
    code: 'travel_arranger',
    label: 'ppTravelArrangerRole',
    value: MemberType.TRAVEL_ARRANGER
  },
  {
    code: 'travel_agent_meeting_and_events',
    label: 'ppTravelAgentMeRole',
    value: MemberType.TRAVEL_AGENT_ME
  },
  {
    code: 'travel_arranger_meeting_and_events',
    label: 'ppTravelArrangerMeRole',
    value: MemberType.TRAVEL_ARRANGER_ME
  }
]
